module.exports = __webpack_public_path__ + "static/media/retail.cd162278.png";